export const hasAttributes = (obj) => obj && typeof obj === "object" && Object.keys(obj).length > 0;

export const hasAttribute = (obj, attributeName) => hasAttributes(obj) && Object.keys(obj).includes(attributeName);

export const getAttributeValue = (obj, attributeName, defaultValue = null) =>
    hasAttribute(obj, attributeName) ? obj[attributeName] : defaultValue;
